import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const wrap = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const box = { background: '#1e293b', borderRadius: 16, padding: 40, width: '100%', maxWidth: 380 };
const inputStyle = { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '10px 14px', color: '#e2e8f0', width: '100%', marginBottom: 12 };
const btnStyle = { background: '#38bdf8', color: '#0f172a', border: 'none', borderRadius: 8, padding: '12px', fontWeight: 700, cursor: 'pointer', width: '100%' };

export default function Login() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const endpoint = mode === 'login' ? '/api/auth/login' : '/api/auth/register';
      const { data } = await api.post(endpoint, form);
      localStorage.setItem('token', data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao autenticar');
    }
  };

  return (
    <div style={wrap}>
      <div style={box}>
        <h1 style={{ textAlign: 'center', marginBottom: 8, color: '#38bdf8' }}>Trading AI</h1>
        <p style={{ textAlign: 'center', color: '#64748b', marginBottom: 28, fontSize: 14 }}>
          {mode === 'login' ? 'Entre na sua conta' : 'Crie sua conta'}
        </p>
        <form onSubmit={handleSubmit}>
          {mode === 'register' && (
            <input style={inputStyle} placeholder="Nome" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required />
          )}
          <input style={inputStyle} type="email" placeholder="Email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
          <input style={inputStyle} type="password" placeholder="Senha" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
          {error && <p style={{ color: '#f87171', fontSize: 13, marginBottom: 8 }}>{error}</p>}
          <button style={btnStyle} type="submit">{mode === 'login' ? 'Entrar' : 'Criar conta'}</button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#64748b' }}>
          {mode === 'login' ? 'Não tem conta?' : 'Já tem conta?'}{' '}
          <span style={{ color: '#38bdf8', cursor: 'pointer' }} onClick={() => setMode(m => m === 'login' ? 'register' : 'login')}>
            {mode === 'login' ? 'Criar' : 'Entrar'}
          </span>
        </p>
      </div>
    </div>
  );
}
